import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/analytics/leaderboard.md?raw';

const AnalyticsLeaderboard: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default AnalyticsLeaderboard;
